export const getCostWithSale = (cost: string, sale: string) => {
    if (!Number(sale)) {
        return cost
    }
    return (Number(cost) * ((100 - Number(sale)) / 100)).toFixed(2)
}
